module.exports = __webpack_public_path__ + "img/task-list-view.24b05ae3.png";